import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button } from '@mui/material';
import AnimatedElement from './AnimatedElement';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <Box id="contact" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
      <Container maxWidth={false} sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>
        
        {/* Header */}
        <AnimatedElement>
          <Box sx={{ mb: 6 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '1.8rem', md: '2.4rem' },
                fontWeight: 500,
                color: '#000'
              }}
            >
              Kontakt aufnehmen
            </Typography>

            <Box
              sx={{
                height: 4,
                width: 90,
                bgcolor: '#3a7b3e',
                mt: 2
              }}
            />
          </Box>
        </AnimatedElement>

        {/* Content Grid */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 6, md: 10 },
            alignItems: 'start'
          }}
        >

          {/* LEFT TEXT */}
          <AnimatedElement>
            <Box>
              <Typography sx={{ fontSize: '1.05rem', lineHeight: 1.7, color: '#111', mb: 2 }}>
                Egal, ob Du Dir vorstellen kannst, bei uns aktiv zu werden oder einfach neue Leute kennenlernen möchtest — melde Dich gern!
              </Typography>
              
              <Typography sx={{ fontSize: '1.05rem', lineHeight: 1.7, color: '#111' }}>
                Am besten bekommt man ein Gefühl für Guestphalia persönlich. Wir freuen uns auf Deine Nachricht.
              </Typography>
            </Box>
          </AnimatedElement>

          {/* FORM */}
          <AnimatedElement>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                p: { xs: 2, md: 4 },
                border: '1px solid #e5e5e5',
                borderRadius: 2,
                bgcolor: '#fafafa'
              }}
            >
              <TextField
                fullWidth
                name="name"
                label="Name"
                value={formData.name}
                onChange={handleInputChange}
                required
                sx={{ mb: 3 }}
              />

              <TextField
                fullWidth
                name="email"
                label="E-Mail"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                sx={{ mb: 3 }}
              />

              <TextField
                fullWidth
                name="message"
                label="Nachricht"
                multiline
                rows={5}
                value={formData.message}
                onChange={handleInputChange}
                required
                sx={{ mb: 3 }}
              />

              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: '#3a7b3e',
                  textTransform: 'none',
                  px: 4,
                  py: 1.5,
                  fontWeight: 500,
                  '&:hover': { bgcolor: '#2d5f31' }
                }}
              >
                Absenden
              </Button>
            </Box>
          </AnimatedElement>

        </Box>
      </Container>
    </Box>
  );
};

export default ContactSection;